import ReactRailsUJS from 'react_ujs';

// ! We get all javascript files, but we should get only entrypoints (components used in "react_component")
// https://github.com/reactjs/react-rails/issues/1134
const context = import.meta.glob('../components/**/*.{js,jsx}', { eager: true });
const webpackRequireContext = (id) => context[`${id.replace('./', '../components/')}.jsx`].default;
ReactRailsUJS.useContext(webpackRequireContext);
